import { createCustomContext } from '@common/context/customContext';

interface StepperContext {
  stepperLoading: boolean;
  setStepperLoading: (value: boolean) => void;
}

export const [useStepperContext, StepperContextProvider] =
  createCustomContext<StepperContext>();
